module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/249-democratic-republic-of-congo-aa8bf3cac60734375bed83a4bc1b06e1.svg";